export var CounterType;
(function (CounterType) {
    CounterType[CounterType["FOLLOWER"] = 10] = "FOLLOWER";
    CounterType[CounterType["VIEW"] = 20] = "VIEW";
    CounterType[CounterType["VOTE"] = 30] = "VOTE";
    CounterType[CounterType["RATING_1"] = 300] = "RATING_1";
    CounterType[CounterType["RATING_2"] = 301] = "RATING_2";
    CounterType[CounterType["RATING_3"] = 302] = "RATING_3";
    CounterType[CounterType["RATING_4"] = 303] = "RATING_4";
    CounterType[CounterType["RATING_5"] = 304] = "RATING_5";
})(CounterType || (CounterType = {}));
//# sourceMappingURL=counter-type.enum.js.map